@if (spinnerStore.isLoading()) {
  <div class="spinner-overlay">
    <div class="spinner-box">
      <div class="spinner-ring">
        <div></div><div></div><div></div><div></div>
      </div>
      <p class="spinner-msg">{{ spinnerStore.loadingMessage() }}</p>
    </div>
  </div>
}
